import styled from "styled-components";


export const BoxAction = styled.div`
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    align-content: center;
`

export const CartIcon = styled.img`
    display: flex;
    margin-right: .5rem;
`


export const TitleCall = styled.span`
    color:#F0E5D9;
`

export const GreenLetter = styled.span`
    color: #8BB326;
`
export const Bold = styled.strong`
    font-weight: 600;
`
export const Space = styled.br``